import { useEffect, useState } from "react";
import AgentComponent from "./AgentComponent";
import CallComponent from "./CallComponent";
import LLMComponent from "./LLMComponent";
import ToolsComponent from "./ToolsComponent";
import TranscriberComponent from "./TranscriberComponent";
import VoiceComponent from "./VoiceComponent";
import { useMediaQuery } from "react-responsive";
import AnalysisComponent from "./AnalysisComponent";
import { useSelector } from "react-redux";
import { Lock } from "lucide-react"; // 🔒 Lucide icon
import SummaryComponent from "./SummaryComponent";
import EvaluationComponent from "./EvaluationComponent";
import StructuredDataComponent from "./StructuredData";

function ContentPanel({ activeTab, assistantDetail }) {
  const [agentPrompt, setAgentPrompt] = useState('');
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const orgIsSubscribed = useSelector((state) => state?.orgData?.orgData?.organization?.isSubscribed);

  useEffect(() => {
    const promptContent =
      assistantDetail?.model &&
        Array.isArray(assistantDetail.model.messages) &&
        assistantDetail.model.messages.length > 0 &&
        typeof assistantDetail.model.messages[0].content === 'string'
        ? assistantDetail.model.messages[0].content
        : 'This is a blank template with minimal defaults.';
    const initialMessage =
      assistantDetail?.firstMessage && typeof assistantDetail.firstMessage === 'string'
        ? assistantDetail.firstMessage
        : '';

    setWelcomeMessage(initialMessage);
    setAgentPrompt(promptContent);
  }, [assistantDetail]);

  const tabContentMap = {
    Agent: (
      <AgentComponent
        welcomeMessage={welcomeMessage}
        agentPrompt={agentPrompt}
      />
    ),
    LLM: <LLMComponent provider={assistantDetail?.model?.provider || ''} model={assistantDetail?.model?.model || ''} />,
    Transcriber: <TranscriberComponent />,
    Voice: <VoiceComponent />,
    Summary: <SummaryComponent />,
    Evaluation: <EvaluationComponent />,
    StructureData: <StructuredDataComponent />,
  };

  const freeAccessTabs = ['Agent', 'LLM', 'Transcriber', 'Voice'];

  const isTabDisabled = !freeAccessTabs.includes(activeTab) && !orgIsSubscribed;
  return (
    <div
      style={{
        position: 'relative',
        overflowY: 'auto',
        height: isMobile ? 'auto' : '80%',
        padding: isMobile ? '0 6px' : '0 10px',
        opacity: isTabDisabled ? 0.6 : 1,
        pointerEvents: isTabDisabled ? 'none' : 'auto',
      }}
    >
      {tabContentMap[activeTab] || null}

      {isTabDisabled && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255,255,255,0.5)',
            zIndex: 10,
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Lock size={32} color="#000" />
          <div style={{ marginTop: 8, fontSize: 14, color: '#000' }}>
            Upgrade your plan to edit this section.
          </div>
        </div>
      )}
    </div>
  );
}


export default ContentPanel;
